import React from 'react'


function NotableEvents () {
    return(<div>Comming Soon</div>)
};

export default NotableEvents;